type Props = {
  label: string;
  active: boolean;
  testId: string;
  onClick: () => void;
};

export function InlineToggleButton({
  label,
  active,
  testId,
  onClick,
}: Readonly<Props>) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-pressed={active}
      className={`text-xs font-medium ${
        active
          ? 'text-prim-700 underline underline-offset-4'
          : 'text-neut-sec hover:text-neut-prim'
      }`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
